import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import ClientHome from '@/pages/ClientHome';
import Checkout from '@/pages/Checkout';
import CheckoutSuccess from '@/pages/CheckoutSuccess';
import LegalPage from '@/components/LegalPage';
import OrderConfirmation from '@/pages/OrderConfirmation';
import TrackOrder from '@/pages/TrackOrder';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import ProtectedRoute from '@/components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Toaster position="top-right" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ClientHome />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/livrare" element={<LegalPage slug="livrare" />} />
            <Route path="/retur" element={<LegalPage slug="retur" />} />
            <Route path="/termeni" element={<LegalPage slug="termeni" />} />
            <Route path="/gdpr" element={<LegalPage slug="gdpr" />} />
            <Route path="/contact" element={<LegalPage slug="contact" />} />
            <Route path="/order-confirmation" element={<OrderConfirmation />} />
            <Route path="/track/:orderId" element={<TrackOrder />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;